module.exports = __webpack_public_path__ + "img/location.75bf3ae9.png";